import { isSpSize } from "../utils/isSpSize";

const CLASS_NAME = ".js-scroll-to";

const init = () => {
  gsap.utils.toArray(CLASS_NAME).forEach((elm) => {
    elm.addEventListener("click", (e) => {
      e.preventDefault();
      const hash = elm.hash;
      if (!hash) return;

      const params = {
        duration: 1,
        scrollTo: {
          y: hash,
          // トップに戻る以外はグローバルヘッダの高さをオフセットする(SPサイズ以上)
          offsetY:
            hash === ("#home" || !isSpSize())
              ? 0
              : document.querySelector("#global_header").offsetHeight,
        },
        ease: "power4.out",
      };

      gsap.to(window, params);
    });
  });
};

export { init };
